import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import FormikDatePicker from 'components/inputs/FormikDatePicker';
import FormikDropdown from 'components/inputs/FormikDropdown';
import Panel from 'components/Panel';
import {DiplomatKey} from 'types/DiplomatKey';
import {DialogTypes} from 'common/names';
import Dialog from 'components/Dialog';
import {FormLabel, Grid, Typography} from '@mui/material';
import {
   IAddOpenPGPSubKey,
   addOpenPGPSubKeySchema,
   AddOpenPGPSubKeyNames,
} from 'types/diplomat/keys/AddOpenPGPSubKey';
import {useSelector} from 'react-redux';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import PollingStatusText from 'features/layout/DialogRoutes/dialogs/keys/components/PollingStatusText';
import FormikPassphrase from 'components/inputs/FormikPassphrase';
import Formik from 'components/hook-form/Formik';
import {useFormStatusContext} from 'common/context/FormStatusContext';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import {ICreateOpenPGPKeyPair} from 'types/diplomat/keys/CreateOpenPGPKeyPair';
import SubkeysExpirationField from './components/SubkeysExpirationField';
import BitStrengthField from './components/BitStrengthField';
import {KeyPairType} from 'types/diplomat/enums/KeyPairType';
import {enums} from 'types/enums';

const Form = () => {
   const {t} = useTranslation();
   const [status] = useFormStatusContext();
   const getValue = useFieldValueGetter<DiplomatKey>();
   const name = getValue('name');
   const keyType = getValue('keyType');

   const isBitstrengthVisible =
      keyType !== KeyPairType.enum.ECDSA &&
      keyType !== KeyPairType.enum.ECDH &&
      keyType !== KeyPairType.enum.EDDSA;

   return (
      <Panel>
         <Grid container direction={'column'}>
            <Grid item xs={12} sm={6}>
               <FormLabel>
                  <Typography>
                     {t('Key Name')} : {name}
                  </Typography>
               </FormLabel>
            </Grid>
            <Grid item xs={5} sm={6}>
               <FormLabel>
                  <Typography>
                     {t('Keys Type')} : {keyType}
                  </Typography>
               </FormLabel>
               {/* <FormikTextField name="algorithm" label={t('Key Type')} disabled /> */}
            </Grid>
            <Grid item xs={12} sm={6}>
               <FormikPassphrase name="passphrase" label={t('Master Key Passphrase')} />
            </Grid>
            {isBitstrengthVisible && (
               <Grid item xs={5} sm={3}>
                  <BitStrengthField />
               </Grid>
            )}
            <Grid item xs={5} sm={3}>
               <FormikDatePicker name="createTime" label={t('Start Date')} disablePast />
            </Grid>
            <Grid item xs={12} container spacing={2}>
               <SubkeysExpirationField />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
               <ExpirationField name={'lifetime'} />
            </Grid> */}
            <Grid item xs={12}>
               <PollingStatusText pollCount={status.pollCount} />
            </Grid>
         </Grid>
      </Panel>
   );
};

type AddOpenPGPSubkeysDialogProps = {
   data?: ICreateOpenPGPKeyPair;
   onClose: (values?: IAddOpenPGPSubKey) => void;
};
export const AddOpenPGPSubkeysDialog = ({data, onClose}: AddOpenPGPSubkeysDialogProps) => {
   const openedKeyData = useSelector(pageSelectors.getData);
   const initialValues = (data ?? openedKeyData) as ICreateOpenPGPKeyPair;
   const handleSubmit = (values: IAddOpenPGPSubKey) => {
      // dispatch(actions.addSubKey(values, helpers));
      onClose(values);
   };

   console.debug('AddOpenPGPSubkeysDialog', initialValues, data);

   return (
      <Dialog maxWidth="md" header={DialogTypes.AddOpenPGPSubkeys.dialogName} close={onClose}>
         <Formik
            enableReinitialize
            initialStatus={{pollCount: 0}}
            initialValues={addOpenPGPSubKeySchema.cast(
               {
                  ...initialValues,
                  // keyId: initialValues.id,
                  passphrase: '',
                  name: initialValues.keyName,
                  keysCount: 3,
                  keysDuration: 365,
               },
               {stripUnknown: true}
            )}
            validationSchema={addOpenPGPSubKeySchema}
            onSubmit={handleSubmit}
         >
            <>
               <Form />
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default AddOpenPGPSubkeysDialog;
